import { withLocale } from '@/util/categoryRoute'

// 活动路由
const activityRoutes = [
  {
    path: withLocale('/zindagi'),
    name: 'zindagi',
    component: () => import('@/views/activity/zindagi/index.vue'),
    meta: {
      cnName: '活动页面',
      enName: 'Activity Page'
    }
  },
  {
    path: withLocale('/congratulations/:slug'),
    name: 'Congrats Form',
    component: () => import('@/views/activity/daily-lucky-draw/congrats'),
    meta: {
      cnName: '抽奖',
      enName: 'Lucky Draw'
    }
  },
  {
    path: withLocale('/congratulations/cashback/:slug'),
    name: 'T3 CashBack',
    component: () => import('@/views/activity/daily-lucky-draw/cashback/index.vue'),
    meta: {
      cnName: '抽奖',
      enName: 'T3 CashBack'
    }
  },
  {
    path: withLocale('/lucky-draw'),
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: withLocale('/luckyDrawPage'),
        name: 'Lucky Draw',
        component: () => import('@/views/activity/daily-lucky-draw/index.vue'),
        meta: {
          cnName: '抽奖',
          enName: 'Lucky Draw'
        }
      },
      {
        path: withLocale('/lucky-no'),
        name: 'Generate Lucky No',
        component: () => import('@/views/activity/daily-lucky-draw/components/GenerateLuckyNumber.vue'),
        meta: {
          cnName: '抽奖',
          enName: 'Lucky Draw'
        }
      },
      {
        path: withLocale('/winner-history'),
        name: 'Winner History',
        component: () => import('@/views/activity/daily-lucky-draw/history/index.vue'),
        meta: {
          cnName: '抽奖',
          enName: 'Winner History'
        }
      },
      {
        path: withLocale('/user-history'),
        name: 'User History',
        component: () => import('@/views/activity/daily-lucky-draw/history/auth.vue'),
        meta: {
          cnName: '抽奖',
          enName: 'User History'
        }
      }
    ]
  },
  {
    path: withLocale('/df-lucky-draw'),
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: withLocale('/apply-df-lucky-draw'),
        name: 'Deep Freezer Lucky Draw',
        component: () => import('@/views/activity/deep-freezer-lucky-draw/index.vue'),
        meta: {
          cnName: '抽奖',
          enName: 'Lucky Draw'
        }
      },
      {
        path: withLocale('/df-lucky-no'),
        name: 'Generate Lucky No',
        component: () => import('@/views/activity/daily-lucky-draw/components/GenerateLuckyNumber.vue'),
        meta: {
          cnName: '抽奖',
          enName: 'Lucky Draw'
        }
      }
    ]
  }
  // 其他活动相关的路由配置
]

export default activityRoutes
